import type { SpinAlgorithmKey } from '../../Generated/SpinAlgorithm.ts'

/** The algorithm every SPIN control defaults to, and the only one shown without `canChooseSpinAlgorithm`. */
export const PREFERRED_SPIN_ALGORITHM: SpinAlgorithmKey = 'SPCFY'

/** The algorithms a user may pick from, out of those the backend reports for a scope. */
export const visibleSpinAlgorithms = (available: readonly string[], mayChoose: boolean): string[] =>
  mayChoose ? [...available] : available.filter((a) => a === PREFERRED_SPIN_ALGORITHM)

/** The preferred algorithm when offered, else the first one; `''` when nothing is. */
export const defaultSpinAlgorithm = (visible: readonly string[]): string =>
  visible.includes(PREFERRED_SPIN_ALGORITHM) ? PREFERRED_SPIN_ALGORITHM : (visible[0] ?? '')

/**
 * The algorithm actually in effect, given what was requested (URL or select; `''` = none) and the
 * visible list (`null` while it is still loading). A request the user may not make — e.g. a
 * `?spinAlgorithm=SWARM` link opened without `canChooseSpinAlgorithm` — falls back to the default.
 */
export const resolveSpinAlgorithm = (requested: string, visible: readonly string[] | null, mayChoose: boolean): string => {
  const permitted = mayChoose || requested === PREFERRED_SPIN_ALGORITHM ? requested : ''
  if (visible === null) return permitted
  return permitted !== '' && visible.includes(permitted) ? permitted : defaultSpinAlgorithm(visible)
}
